<template>
  <div>
    <div class="serve-flex-col serve-items-start section_2 space-y-68">
      <span class="text_8">新闻资讯</span>
      <span class="text_9">聚焦行业资讯，标准规范。</span>
    </div>
    <New1 v-show="sort == 1" />
    <New2 v-show="sort == 2" />
    <New3 v-show="sort == 3" />
  </div>
</template>

<script>
import New1 from "./new1.vue";
import New2 from "./new2.vue";
import New3 from "./new3.vue";
export default {
  components: {
    New1,
    New2,
    New3,
  },
  data() {
    return {
      sort: 1,
    };
  },
};
</script> 

<style scoped>
/************************************************************
** 请将全局样式拷贝到项目的全局 CSS 文件或者当前页面的顶部 **
** 否则页面将无法正常显示                                  **
************************************************************/

html {
  font-size: 256px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    "Microsoft Yahei", sans-serif;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}

#app {
  width: 100vw;
  height: 100vh;
}

.serve-flex-row {
  display: flex;
  flex-direction: row;
}

.serve-flex-col {
  display: flex;
  flex-direction: column;
}

.serve-justify-start {
  justify-content: flex-start;
}

.serve-justify-end {
  justify-content: flex-end;
}

.serve-justify-center {
  justify-content: center;
}

.serve-justify-between {
  justify-content: space-between;
}

.serve-justify-around {
  justify-content: space-around;
}

.serve-justify-evenly {
  justify-content: space-evenly;
}

.serve-items-start {
  align-items: flex-start;
}

.serve-items-end {
  align-items: flex-end;
}

.serve-items-center {
  align-items: center;
}

.serve-items-baseline {
  align-items: baseline;
}

.serve-items-stretch {
  align-items: stretch;
}

.serve-self-start {
  align-self: flex-start;
}

.serve-self-end {
  align-self: flex-end;
}

.serve-self-center {
  align-self: center;
}

.serve-self-baseline {
  align-self: baseline;
}

.serve-self-stretch {
  align-self: stretch;
}

.serve-flex-1 {
  flex: 1 1 0%;
}

.serve-flex-auto {
  flex: 1 1 auto;
}

.serve-grow {
  flex-grow: 1;
}

.serve-grow-0 {
  flex-grow: 0;
}

.serve-shrink {
  flex-shrink: 1;
}

.serve-shrink-0 {
  flex-shrink: 0;
}

.serve-relative {
  position: relative;
}
.section_2 {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 2.09rem;
  padding: 0.67rem 1.25rem 0.83rem;
  background-image:url("https://official-1317286948.cos.ap-beijing.myqcloud.com/nav5.webp"), url("https://official-1317286948.cos.ap-beijing.myqcloud.com/home-head-4.png");
  margin-bottom: 0.4rem;
}
.space-y-68 > *:not(:first-child) {
  margin-top: 0.27rem;
}
.text_8 {
  color: #ffffff;
  font-size: 0.23rem;
  font-family: PingFang;
  font-weight: 700;
  line-height: 0.22rem;
}
.text_9 {
  color: #ffffff;
  font-size: 0.1rem;
  font-family: PingFang;
  line-height: 0.1rem;
}

.image_2 {
  width: 2.61rem;
  height: 1.18rem;
}

.image_3 {
  margin-right: 0.031rem;
  width: 2.35rem;
  height: 1.18rem;
}
</style>



// WEBPACK FOOTER //
// src/views/news.vue